import {
  Component,
  HostBinding,
  HostListener,
  Input,
  OnInit,
} from "@angular/core";
import { LayoutViewModel } from "../view-models/layout.view-model";

@Component({
  selector: "evrideo-layout-visual-editor",
  templateUrl: "./layout-visual-editor.component.html",
  styleUrls: ["./layout-visual-editor.component.scss"],
})
export class LayoutVisualEditorComponent implements OnInit {
  @HostBinding("style.width")
  hostWidth: string;

  @HostBinding("style.height")
  hostHeight: string;

  @Input()
  vm: LayoutViewModel;
  constructor() {}

  ngOnInit(): void {
    this.hostHeight = this.vm.viewPortHeight + "%";
    this.hostWidth = this.vm.viewPortWidth + "vh";
  }
}
